module.exports = __webpack_public_path__ + "img/icon - emoji smile.90107da6.png";